var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoodsList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 17,
    height: 17
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.625 5.5H13.375"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.625 9.5H13.375"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.625 13.5H13.375"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoodsList);
export default __webpack_public_path__ + "static/media/goodsList.ac978134abb22de800ee5f9db7969c61.svg";
export { ForwardRef as ReactComponent };